// IMPORT FUNCTIONS AND SERVICES
import PostDataComplex from '../../../../../services/PostDataComplex';
// import PostData from './PostData';


const deleteImage = async (img_id, callback) => {
  console.log('deleteImage()');

  console.log(`img_id: ${img_id}`);
  
  const user_name = (JSON.parse(sessionStorage.userData)).user.usr_name;
  console.log(`user_name: ${user_name}`);
  const user_token = (JSON.parse(sessionStorage.userData)).user.token;
  console.log(`user_token: ${user_token}`);

  const data = {
    user: user_name,
    token: user_token,
    img_id: img_id,
  }

  const localHost = String(window.location).split('/')[2].includes('localhost');
  const network = String(window.location).split('/')[2].includes('10.0.0.6');
  console.log(`localHost: ${localHost}`);
  console.log(`network: ${network}`);
  
  const successMessage = 'image permanently deleted succesfully!!!';
  const errorMessage = 'error removing permanently image!!!';

  if( localHost || network) {
    console.log('LOCALE NOT MANAGED!!!');

    if(true) {
      console.log(successMessage);
          
      const result = {
        message: successMessage,
        image: 'deleted',
      } 
      console.log(`message: ${successMessage}`);
      callback(result);

    } else {

      console.log(errorMessage);

      const result = {
        message: errorMessage,
        error: 'general error!!!' ,
      } 
      console.log(`error: ${result.error}`);
      callback(result);

    }

  } else {

    PostDataComplex('images_manager', 'POST', 'deleteImage', data)
      .then((response) => {
        console.log('response.data:->');
        console.log(response.data);

        const deleteImageData = response.data.feedBack.deleteImageData;
            
        if(deleteImageData.img_deleted || deleteImageData.img_mini_deleted) {
          deleteImageData.img_deleted ? console.log('image removed succesfully!!!') : console.log('image not removed!!!');
          deleteImageData.img_mini_deleted ? console.log('image_mini removed succesfully!!!') : console.log('image_mini not removed!!!');

          const result = {
            message: deleteImageData.img_deleted + ' - ' + deleteImageData.img_mini_deleted,
            imagesDeleted: true,
          } 
          console.log(`message: ${result.message}`);
          callback(result);
          
        } else {
          console.log(errorMessage);

          const result = {
            message: errorMessage,
            error: deleteImageData.error ,
          } 
          console.log(`error: ${result.error}`);
          callback(result);

        }
      }
    )

  }

}

export default deleteImage;